import type { BedrockInferenceProfileId } from "@arti/ai-models-config";

export const PROVIDERS = [
  "anthropic",
  "azure",
  "bedrock",
  "google",
  "openai",
  "openrouter",
  "vertex",
] as const;

export const PROVIDER_LABELS: Record<string, string> = {
  anthropic: "Anthropic",
  azure: "Azure AI Foundry",
  bedrock: "Amazon Bedrock",
  google: "Google Generative AI",
  openai: "OpenAI",
  openrouter: "OpenRouter",
  vertex: "Vertex AI",
};

export const PROVIDER_OPTIONS = [
  { label: "Anthropic", value: "anthropic" },
  { label: "Azure AI Foundry", value: "azure" },
  { label: "Amazon Bedrock", value: "bedrock" },
  { label: "Google Generative AI", value: "google" },
  { label: "OpenAI", value: "openai" },
  { label: "OpenRouter", value: "openrouter" },
  { label: "Vertex AI", value: "vertex" },
];

export const MULTI_FIELD_PROVIDER_KEYS: Record<
  string,
  { isSecret: boolean; label: string; placeholder: string; value: string }[]
> = {
  azure: [
    {
      isSecret: false,
      label: "Endpoint",
      placeholder: "https://arti-foundry-eu.cognitiveservices.azure.com",
      value: "endpoint",
    },
    {
      isSecret: true,
      label: "API key",
      placeholder: "Azure Foundry API key",
      value: "apiKey",
    },
  ],
  vertex: [
    {
      isSecret: true,
      label: "API key",
      placeholder: "Vertex API key",
      value: "apiKey",
    },
    {
      isSecret: false,
      label: "Location",
      placeholder: "global",
      value: "location",
    },
    {
      isSecret: false,
      label: "Project",
      placeholder: "my-gcp-project",
      value: "project",
    },
  ],
};

/**
 * Global Inference Profile IDs available via Amazon Bedrock.
 */
export const BEDROCK_MODEL_OPTIONS: {
  label: string;
  value: BedrockInferenceProfileId;
}[] = [
  { label: "Claude Fable 5.1", value: "global.anthropic.claude-fable-5-1" },
  { label: "Claude Fable 5", value: "global.anthropic.claude-fable-5" },
  { label: "Claude Opus 5.5", value: "global.anthropic.claude-opus-5-5" },
  { label: "Claude Opus 5", value: "global.anthropic.claude-opus-5" },
  { label: "Claude Opus 4.7", value: "global.anthropic.claude-opus-4-7" },
  { label: "Claude Opus 4.6", value: "global.anthropic.claude-opus-4-6-v1" },
  { label: "Claude Sonnet 5", value: "global.anthropic.claude-sonnet-5" },
  { label: "Claude Sonnet 4.6", value: "global.anthropic.claude-sonnet-4-6" },
  {
    label: "Claude Opus 4.5",
    value: "global.anthropic.claude-opus-4-5-20251101-v1:0",
  },
  {
    label: "Claude Sonnet 4.5",
    value: "global.anthropic.claude-sonnet-4-5-20250929-v1:0",
  },
  {
    label: "Claude Haiku 4.5",
    value: "global.anthropic.claude-haiku-4-5-20251001-v1:0",
  },
  { label: "Amazon Nova 2 Lite", value: "global.amazon.nova-2-lite-v1:0" },
];
